import { useState, useEffect } from 'react';
import { Group, Header, FormItem, Input, Button } from '@vkontakte/vkui';
import { useSimulator } from '../../api/hooks';
import { api } from '../../api/client';

export function AdminSimulator() {
  const { data } = useSimulator();
  const [url, setUrl] = useState('');
  const [version, setVersion] = useState('');

  useEffect(() => {
    if (data?.downloadUrl) setUrl(data.downloadUrl);
    if (data?.version) setVersion(data.version);
  }, [data]);

  const save = async () => {
    await api('/api/admin/simulator', {
      method: 'PATCH',
      body: JSON.stringify({
        downloadUrl: url,
        version,
        releasedAt: new Date().toISOString(),
      }),
    });
  };

  return (
    <Group header={<Header size="s">Дистрибутив симулятора</Header>}>
      <FormItem top="URL скачивания">
        <Input value={url} onChange={(e) => setUrl(e.target.value)} />
      </FormItem>
      <FormItem top="Версия">
        <Input value={version} onChange={(e) => setVersion(e.target.value)} />
      </FormItem>
      <FormItem>
        <Button stretched className="pb-gradient-btn" onClick={save}>
          Сохранить
        </Button>
      </FormItem>
    </Group>
  );
}
